import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { ServiceDeleteBase } from "../base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoEquipoListService } from "./CostoEquipoListService";

/** Baja de equipos; la saca del listado en memoria. */
export class CostoEquipoDeleteService extends ServiceDeleteBase {
  static readonly instance = new CostoEquipoDeleteService();
  private constructor() { super(); }

  protected readonly cache = CostoEquipoListService.instance;

  /** gRPC-Web (`EliminarEquipo`): baja lógica del equipo y su costo; `NotFoundError` si no existe. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(CostosPlataformaService).eliminarEquipo({ id }));
  }
}
